export enum SessionRole {
  STARTER = 'STARTER',
  USER = 'USER',
  USER_WITH_ACCESS = 'USER_WITH_ACCESS',
  ADMIN = 'ADMIN',
  ADMIN_WITH_ACCESS = 'ADMIN_WITH_ACCESS',
  SUPER_ADMIN = 'SUPER_ADMIN',
}
